import { Box, Link, Stack } from "@mui/material"
import "./styles.scss"
import { TTagFilterMenu } from "./types"
import { areAllPropertiesEmpty, Button, Chip, EmailAPIFactory, Header, InlineTextEdit, TGenericListReturn, Typography } from "cakemail-ui-components-v2"
import { useTranslation } from "react-i18next"
import { ChangeEvent, MouseEvent, MouseEventHandler, useEffect, useState } from "react"
import { TButtonRef } from "cakemail-ui-components-v2/dist/esm/components/button/types"
import { SimpleQueryBuilder } from "../simpleQueryBuilder"

export function TagFilterMenu({ onClose, initTags, initCustomReport, onSave, metadataName }: TTagFilterMenu) {
    const { t, i18n } = useTranslation()

    const [emailTags, setEmailTags] = useState<TGenericListReturn<string>>()
    const [query, setQuery] = useState<any>(initCustomReport?.query || {

    })

    useEffect(() => {
        if (!initTags) {
            fetchEmailTags
        }
    }, [])

    function fetchEmailTags() {
        EmailAPIFactory.listTags({ perPage: 200 }).then((data) => {
            setEmailTags(data)
        })
    }

    function handleHeadingChange(event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
        throw new Error("Function not implemented.")
    }

    function handleInlineConfirm({ name, value }: { name?: string; value?: string }) {
        throw new Error("Function not implemented.")
    }

    function clearQuery() {
        debugger
    }

    function handleOnSave(event: MouseEvent<HTMLButtonElement>, btnRef: TButtonRef) {

        //todo save function to account metaData

        if (onSave)
            onSave(event, btnRef)
    }

    function handleQueryChange(q: any) {
        console.log(q)
        EmailAPIFactory.getReport({
            tags: areAllPropertiesEmpty(q) ? undefined : q
        }).then((r) => {
            console.log("good", r)
        }).catch(({ msg, code, data, response }) => {
            console.log("err", msg, code, data)
        })
        setQuery(q)
    }

    return <Stack className="tagFilterMenu">
        <Stack className="mainContainer" gap={8}>
            <Header
                support={t("filter-menu-custom-email-report-support")}
                heading={<InlineTextEdit tooltipTitle={""} onChange={handleHeadingChange} onConfirm={handleInlineConfirm}>{"Heading"}</InlineTextEdit>}
                headingVariant="displayS"
                desc={<InlineTextEdit tooltipTitle={""} onChange={handleHeadingChange} onConfirm={handleInlineConfirm}>{"DESC"}</InlineTextEdit>}
            />

            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Stack direction="row" gap={2} alignItems="center">
                    <Typography variant="body1L" className="semiBold">{t("general-tags")}</Typography> <Chip squared color="secondary" label={1} />
                </Stack>
                <Link onClick={clearQuery}> <Typography variant="body2" className="uppercase">{t("general-tags")}</Typography></Link>
            </Stack>
            <SimpleQueryBuilder query={query} updateQuery={handleQueryChange} />
        </Stack>

        <Stack className="actionContainer" direction="row" gap={3}>
            <Button color="cloud" onClick={onClose}>{t("general-cancel")}</Button>
            <Button color="secondary" onClick={handleOnSave}>{t("general-save")}</Button>
        </Stack>
    </Stack>
}